import { ArrowDownRight } from 'lucide-react';
import { ArticleCard } from '../components/ArticleCard';
import { articles } from '../content/articles';

export const GuidesPage = () => (
  <main id="top" className="as-guides-page">
    <header className="as-guides-hero">
      <div>
        <p className="as-descriptor">Guides d’achat automobile</p>
        <h1>Choisir une voiture commence par les bonnes questions.</h1>
      </div>
      <div className="as-guides-hero-copy">
        <p>
          Budgets, motorisations, financement et achat d’occasion : des réponses développées
          pour décider, avec leurs sources, leurs hypothèses et leurs limites.
        </p>
        <a href="#articles">Voir les guides <ArrowDownRight size={17} aria-hidden="true" /></a>
      </div>
    </header>

    <section className="as-editorial-method" aria-labelledby="editorial-method-title" data-motion="split">
      <div>
        <h2 id="editorial-method-title">Une méthode de lecture, pas un palmarès.</h2>
        <p>
          Les prix de marché sont datés, les règles renvoient à leurs sources publiques et les
          recommandations restent liées à un usage. Une voiture peut être excellente et ne pas
          être la bonne pour vous.
        </p>
      </div>
      <dl>
        <div><dt>Fait</dt><dd>Information vérifiable, reliée à une source.</dd></div>
        <div><dt>Estimation</dt><dd>Fourchette construite avec une date et des hypothèses.</dd></div>
        <div><dt>Avis</dt><dd>Arbitrage argumenté, clairement présenté comme tel.</dd></div>
      </dl>
    </section>

    <section id="articles" className="as-guides-index" aria-labelledby="guides-index-title">
      <div className="as-guides-index-heading" data-motion="wipe">
        <h2 id="guides-index-title">Les conseils Auto Sens</h2>
        <p>{articles.length} dossiers à lire selon votre point de départ.</p>
      </div>
      <nav aria-label="Choisir un guide selon votre question">
        <ul>
          <li><a href="/conseils/essence-diesel-hybride-electrique/#essence-ou-hybride">Essence ou hybride pour mes trajets quotidiens ?</a></li>
          <li><a href="/conseils/essence-diesel-hybride-electrique/#hybride-ou-diesel-autoroute">Hybride ou diesel : que choisir selon mes trajets ?</a></li>
          <li><a href="/conseils/quel-suv-30000-euros/">Quel SUV d’occasion choisir avec 30 000 € ?</a></li>
        </ul>
      </nav>
      <div className="as-guides-list">
        {articles.map((article, index) => (
          <ArticleCard key={article.slug} article={article} featured={index === 0} motionIndex={index % 2} />
        ))}
      </div>
    </section>

    <section className="as-guides-cta" data-motion="split">
      <div>
        <h2>Votre besoin ne rentre pas dans une requête Google.</h2>
        <p>
          Le conseil personnalisé relie votre budget, vos trajets, votre famille, votre
          stationnement et votre horizon de détention dans une seule shortlist.
        </p>
      </div>
      <a className="as-button as-button-lime" href="/#contact">Décrire mon projet</a>
    </section>
  </main>
);
